import { TableParams } from 'types/common';
import { HomePageResponseViewModel } from 'types/home-page';

export type State = {
    isLoading: boolean;
    list: HomePageResponseViewModel[];
    tableParams: TableParams;
    totalCount: number;
};

export const tableColumns = [
    {
        id: 'isActive',
        field: 'isActive',
        label: 'Active',
    },
    {
        id: 'description',
        field: 'description',
        label: 'Description',
    },
    {
        id: 'createdDate',
        field: 'createdDate',
        label: 'Created Date',
    },
    {
        id: 'updatedDate',
        field: 'updatedDate',
        label: 'Updated Date',
    },
];

export const initialHomePagesTableParams: TableParams = {
    sortOrder: 'asc',
    orderBy: tableColumns[0].field,
    page: 0,
    pageSize: 5,
    search: undefined,
};

export const initialState: State = {
    isLoading: true,
    list: [],
    tableParams: initialHomePagesTableParams,
    totalCount: 0,
};
